/*
  GO Motorsports cart: cart drawer and cart page.
  - Opens the drawer after an add (event 'cart:added' from go-product.js) or a click on the header cart icon.
  - Quantity changes, removals and the order note update in place through /cart/change.js and /cart/update.js,
    re-rendering every cart section on the page (drawer and cart page) with the Section Rendering API.
  - Fires 'cart:updated' with the cart so the header badge updates.
*/
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var strings = window.goStrings || {};
  var drawer = document.querySelector('[data-cart-drawer]');
  var returnFocus = null;
  var timers = {};
  window.goCartDrawer = !!drawer;

  function sectionIds() {
    return Array.prototype.map.call(document.querySelectorAll('[data-cart-root]'), function (el) { return el.dataset.sectionId; });
  }

  function announce(message) {
    document.querySelectorAll('[data-cart-status]').forEach(function (el) {
      el.textContent = '';
      setTimeout(function () { el.textContent = message; }, 50);
    });
  }

  function setBusy(busy) {
    document.querySelectorAll('[data-cart-root]').forEach(function (el) { el.classList.toggle('is-updating', busy); });
  }

  /* Replace each cart root with its freshly rendered version, keeping focus where it was. */
  function renderSections(sections) {
    if (!sections) return;
    var active = document.activeElement;
    var activeLine = active && active.closest('[data-line]') ? active.closest('[data-line]').dataset.key : null;
    var activeSelector = active && active.matches('[data-line-qty]') ? '[data-line-qty]' : (active && active.matches('[data-cart-note]') ? '[data-cart-note]' : null);
    Object.keys(sections).forEach(function (id) {
      var target = document.querySelector('[data-cart-root][data-section-id="' + id + '"]');
      if (!target || !sections[id]) return;
      var doc = new DOMParser().parseFromString(sections[id], 'text/html');
      var fresh = doc.querySelector('[data-cart-root]');
      if (fresh) target.innerHTML = fresh.innerHTML;
    });
    if (activeSelector) {
      var scope = activeLine ? document.querySelector('[data-line][data-key="' + activeLine + '"]') : document;
      var next = scope && scope.querySelector(activeSelector);
      if (next) next.focus({ preventScroll: true });
    }
  }

  function refresh() {
    var ids = sectionIds();
    if (!ids.length) return Promise.resolve();
    return fetch(root + '?sections=' + ids.join(','))
      .then(function (r) { return r.json(); })
      .then(renderSections);
  }

  function publish(cart) {
    if (cart && typeof cart.item_count === 'number') {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    } else {
      fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: c }));
      });
    }
  }

  /* ---------- Line changes ---------- */
  function changeLine(lineEl, quantity) {
    var line = Number(lineEl.dataset.line);
    var errorEl = lineEl.querySelector('[data-line-error]');
    setBusy(true);
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: sectionIds(), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || strings.cartError);
        renderSections(res.body.sections);
        publish(res.body);
        announce(quantity === 0 ? strings.cartRemoved || 'Item removed' : strings.cartUpdated || 'Cart updated');
      })
      .catch(function (err) {
        // Put the real quantities back, then show the message on the line.
        refresh().then(function () {
          var fresh = document.querySelector('[data-line][data-key="' + lineEl.dataset.key + '"] [data-line-error]');
          var box = fresh || errorEl;
          if (box) { box.textContent = err.message; box.hidden = false; }
          announce(err.message);
        });
      })
      .finally(function () { setBusy(false); });
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (!input) return;
    var lineEl = input.closest('[data-line]');
    clearTimeout(timers[lineEl.dataset.key]);
    timers[lineEl.dataset.key] = setTimeout(function () {
      changeLine(lineEl, Math.max(0, parseInt(input.value, 10) || 0));
    }, 350);
  });

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-line-remove]');
    if (!remove) return;
    e.preventDefault();
    changeLine(remove.closest('[data-line]'), 0);
  });

  /* Order note: saved a moment after typing stops. */
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-cart-note]')) return;
    clearTimeout(timers.note);
    var note = e.target.value;
    timers.note = setTimeout(function () {
      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: note })
      });
    }, 600);
  });

  /* ---------- Drawer ---------- */
  function openDrawer() {
    if (!drawer) return;
    returnFocus = returnFocus || document.activeElement;
    drawer.hidden = false;
    document.body.classList.add('has-drawer-open');
    document.querySelectorAll('[data-cart-link]').forEach(function (a) { a.setAttribute('aria-expanded', 'true'); });
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      drawer.querySelector('[data-cart-drawer-panel]').focus();
    });
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('has-drawer-open');
    document.querySelectorAll('[data-cart-link]').forEach(function (a) { a.setAttribute('aria-expanded', 'false'); });
    setTimeout(function () { drawer.hidden = true; }, 300);
    if (returnFocus && returnFocus.focus) returnFocus.focus();
    returnFocus = null;
  }
  window.goOpenCart = openDrawer;

  if (drawer) {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-cart-link]');
      if (link) { e.preventDefault(); returnFocus = link; openDrawer(); return; }
      if (e.target.closest('[data-cart-drawer-close]')) closeDrawer();
    });
    document.addEventListener('keydown', function (e) {
      if (drawer.hidden) return;
      if (e.key === 'Escape') { closeDrawer(); return; }
      if (e.key !== 'Tab') return;
      var panel = drawer.querySelector('[data-cart-drawer-panel]');
      var items = Array.prototype.filter.call(
        panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea, summary, iframe'),
        function (el) { return el.offsetParent !== null; }
      );
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    document.addEventListener('cart:added', function () {
      returnFocus = document.activeElement;
      refresh().then(openDrawer);
    });
  } else {
    // No drawer: keep every cart section on the page in sync after an add.
    document.addEventListener('cart:added', function () { refresh(); });
  }

  // Pages restored from the back-forward cache can show an old cart.
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
})();
